'use strict';

var React = require('react');

var SvgIconsIcon = function SvgIconsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.11 15h-2.36a1.75 1.75 0 0 1-1.75-1.75v-4.3a3.5 3.5 0 1 1 5.663-3.95h4.587c.966 0 1.75.784 1.75 1.75v6.5a1.75 1.75 0 0 1-.781 1.458l.679 1.164a.75.75 0 0 1-.648 1.128h-7a.75.75 0 0 1-.648-1.128l.509-.872Zm-1.61-6.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 1.5a3.5 3.5 0 0 0 3.5-3.5h4.25a.25.25 0 0 1 .25.25v6.5a.248.248 0 0 1-.047.146l-2.055-3.524a.75.75 0 0 0-1.296 0l-2.116 3.628h-3.236a.25.25 0 0 1-.25-.25v-3.395a3.5 3.5 0 0 0 1 .145Zm5.25 1.739 2.194 3.761h-4.388l2.194-3.761Z"
  }));
};
SvgIconsIcon.displayName = "IconsIcon";

exports.SvgIconsIcon = SvgIconsIcon;
